/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EditDeviceTokenQuery model module.
 * @module model/EditDeviceTokenQuery
 * @version 0.0.1
 */
class EditDeviceTokenQuery {
    /**
     * Constructs a new <code>EditDeviceTokenQuery</code>.
     * @alias module:model/EditDeviceTokenQuery
     */
    constructor() { 
        
        EditDeviceTokenQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EditDeviceTokenQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EditDeviceTokenQuery} obj Optional instance to populate.
     * @return {module:model/EditDeviceTokenQuery} The populated <code>EditDeviceTokenQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EditDeviceTokenQuery();

            if (data.hasOwnProperty('tokenLongId')) {
                obj['tokenLongId'] = ApiClient.convertToType(data['tokenLongId'], 'String');
            }
            if (data.hasOwnProperty('tokenLabel')) {
                obj['tokenLabel'] = ApiClient.convertToType(data['tokenLabel'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EditDeviceTokenQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EditDeviceTokenQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['tokenLongId'] && !(typeof data['tokenLongId'] === 'string' || data['tokenLongId'] instanceof String)) {
            throw new Error("Expected the field `tokenLongId` to be a primitive type in the JSON string but got " + data['tokenLongId']);
        }
        // ensure the json data is a string
        if (data['tokenLabel'] && !(typeof data['tokenLabel'] === 'string' || data['tokenLabel'] instanceof String)) {
            throw new Error("Expected the field `tokenLabel` to be a primitive type in the JSON string but got " + data['tokenLabel']);
        }

        return true;
    }


}



/**
 * @member {String} tokenLongId
 */
EditDeviceTokenQuery.prototype['tokenLongId'] = undefined;

/**
 * @member {String} tokenLabel
 */
EditDeviceTokenQuery.prototype['tokenLabel'] = undefined;






export default EditDeviceTokenQuery;

